import React from 'react'
import cx from 'classnames';

export default function CardNews({img,title,label,onClick,gallery,similar,onlanding}) {
  const blurClass = cx({
    'border border-white rounded-2xl wrapperBlur': gallery ? false : true,
  })
  const bgLabel = cx({
    "bg-white labelWrap rounded-2xl text-black": gallery ? false : true,
    "font-light text-white": gallery,
    "hidden":label === '' || label === undefined
  });
  return (
    <div
      className={onlanding ?  "relative cardNewsWrapper rounded-2xl":"relative cursor-pointer cardNewsWrapper rounded-2xl"}
      onClick={onClick}
    >
      <img
        crossOrigin="anonymous"
        src={img}
        alt={title}
        className={
          similar
            ? "rounded-2xl h-[207px]"
            : `rounded-2xl h-[207px] md:h-[307px]`
        }
      />
      <div className="absolute w-full px-5 mx-auto bottom-4">
        <span className={`px-2 py-1 mx-3 font-light ${bgLabel}`}>{label}</span>
        <div className={`px-5 py-3 mt-[9px] ${blurClass}`}>
          <h1 className="font-bold leading-relaxed text-white overflow-clip">
            {title.substring(0, 60)}
          </h1>
        </div>
      </div>
    </div>
  );
}
